import AboutPrincipes from './AboutPrincipes';

export default AboutPrincipes;
